const lineHeights = {
    base: 1.5,
};
export default lineHeights;
